import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { NavLink } from 'react-router-dom';
import visa from "../../../assets/images/visa_logo_400x250.jpg";
import mastercard from "../../../assets/images/mc_vrt_opt_pos_73_3x.png";
import maestro from "../../../assets/images/ms_vrt_opt_pos_73_3x.png";
import monri from "../../../assets/images/monri_badge.png";
import { IconsLibrary } from '../../util/FontAwesomeIconsUtil';
import Play from '../../../assets/images/Play';
import AppStore from '../../../assets/images/AppStore';
import { useAuthContext } from '../../auth/AuthContext';
import { useMediaQuery } from 'react-responsive';

export default function Footer(props) {

    const isSmallerThanDesktop = useMediaQuery({ query: '(max-width: 1279px)' });

    const { auth } = useAuthContext();

    React.useEffect(() => {
        if (!!isSmallerThanDesktop) {
            window.addEventListener("beforeunload", () => {
                window.scrollTo(0,0);
            });
        }
        return () => {
            window.removeEventListener("beforeunload", null);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <footer className="mt-10 text-white text-opacity-80">

            {/* footer shortcuts */}
            <div className="bg-purple">
                <nav className="container py-6 mx-auto">
                    <ul className="flex flex-wrap justify-center w-full text-lg font-semibold">
                        {!auth.isAuthenticated && <li className="py-2 px-4">
                            <NavLink to="/registracija" title="Registracija">Registracija</NavLink>
                        </li>}
                        {!auth.isAuthenticated && <li className="py-2 px-4">
                            <NavLink to={{ pathname: "https://blog.roba.ba/" }} target="_blank" title="Blog">Blog</NavLink>
                        </li>}
                        {!auth.isAuthenticated && <li className="py-2 px-4">
                            <NavLink to="/kategorije" title="Kategorije">Kategorije</NavLink>
                        </li>}
                        {!auth.isAuthenticated && <li className="py-2 px-4">
                            <NavLink to={{ pathname: "https://podrska.roba.ba/kontakt/" }} target="_blank" title="Kontakt">Kontakt</NavLink>
                        </li>}
                        {!!auth.isAuthenticated && <li className="py-2 px-4">
                            <NavLink to="/auto-moto/automobili/kategorija/50029" title="Automobili">Automobili</NavLink>
                        </li>}
                        {!!auth.isAuthenticated && <li className="py-2 px-4">
                            <NavLink to="/nekretnine/kategorija/50015" title="Nekretnine">Nekretnine</NavLink>
                        </li>}
                        {!!auth.isAuthenticated && <li className="py-2 px-4">
                            <NavLink to="/mobilni-ureaji-i-oprema/mobilni-telefoni/kategorija/50132" title="Mobilni telefoni">Mobilni telefoni</NavLink>
                        </li>}
                        {!!auth.isAuthenticated && <li className="py-2 px-4">
                            <NavLink to="/sport-i-sportska-oprema/kategorija/50008" title="Sport">Sport</NavLink>
                        </li>}
                        {!!auth.isAuthenticated && <li className="py-2 px-4">
                            <NavLink to="/turizam/kategorija/50001" title="Sport">Turizam</NavLink>
                        </li>}
                        {!!auth.isAuthenticated && <li className="py-2 px-4">
                            <NavLink to="/kategorije" title="Kategorije">Kategorije</NavLink>
                        </li>}
                    </ul>
                </nav>
            </div>

            {/* footer columns */}
            <div className="bg-indigo">
                <div className="container px-3 flex flex-col md:flex-row flex-wrap justify-between items-center mx-auto pt-10 pb-1 md:pb-10 lg:pb-2">

                    {/* left column */}
                    <section className="flex flex-col flex-wrap items-center justify-center text-center md:text-left md:items-start md:justify-start min-w-xs w-full md:w-2/5">
                        <p className="uppercase font-bold tracking-wider">
                            Roba.ba
                        </p>
                        <nav>
                            <ul className="my-3 tracking-wide">
                                <li className="my-2">
                                    <NavLink to="/o-nama" title="O nama">O nama</NavLink>
                                </li>
                                <li className="my-2">
                                    <NavLink to="/impressum" title="Impressum">Impressum</NavLink>
                                </li>
                                {/* <li className="my-2">
                                    <NavLink to="/cjenovnik">Cjenovnik</NavLink>
                                </li> */}
                                <li className="my-2">
                                    <NavLink to="/sigurnost-placanja" title="Sigurnost plaćanja">Sigurnost plaćanja</NavLink>
                                </li>
                                <li className="my-2">
                                    <NavLink to="/pravila-i-uslovi-koriscenja" title="Pravila i uslovi korišćenja">Pravila i uslovi korišćenja</NavLink>
                                </li>
                                <li className="my-2">
                                    <NavLink to="/politika-privatnosti" title="Politika privatnosti">Politika privatnosti</NavLink>
                                </li>
                            </ul>
                        </nav>
                    </section>

                    {/* middle column */}
                    <section className="flex flex-col items-center justify-center min-w-xs my-2 w-full md:w-1/5">

                        {/* social icons */}
                        <div className="flex flex-nowrap items-center justify-start space-x-4 text-4xl opacity-60">
                            <a href="https://www.instagram.com/stiglaroba/" target="_blank" aria-label="Instagram" rel="noreferrer"><FontAwesomeIcon icon={IconsLibrary.fabInstagram} /></a>
                            <a href="https://www.facebook.com/stiglaroba.ba/" target="_blank" aria-label="Facebook" rel="noreferrer"><FontAwesomeIcon icon={IconsLibrary.fabfaFacebook} /></a>
                            <a href="https://www.youtube.com/channel/UC_Ycsu5Yk3Rb0LyZJf7geWw" aria-label="Youtube" target="_blank" rel="noreferrer"><FontAwesomeIcon icon={IconsLibrary.fabYoutube} /></a>
                            <a href="https://twitter.com/stiglaroba" aria-label="Twitter" target="_blank" rel="noreferrer"><FontAwesomeIcon icon={IconsLibrary.fabTwitter} /></a>
                            <a href="https://tiktok.com/@stiglaroba" aria-label="TikTok" target="_blank" rel="noreferrer"><FontAwesomeIcon icon={IconsLibrary.fabTiktok} /></a>
                        </div>
                        {/* download app icons */}
                        <div className="flex flex-col space-y-10 mb-6 md:flex-row md:flex-nowrap md:mb-0 md:space-y-0 lg:flex-row lg:flex-nowrap lg:space-y-0 lg:mb-0 mt-8 space-x-0 opacity-60">
                            <a href="https://play.google.com/store/apps/details?id=com.robaba.mobile&pcampaignid=web_share" target="_blank" aria-label="Google Play Store" rel="noreferrer"><Play className="w-18 h-14" /></a>
                            <a href="https://apps.apple.com/us/app/roba-ba/id6471488879" target="_blank" aria-label="App Store" rel="noreferrer"><AppStore className="w-18 h-14" /></a>
                        </div>
                    </section>

                    {/* right column */}
                    <section className="flex flex-col flex-wrap items-center text-center justify-center md:text-right md:items-end md:justify-end w-full md:w-2/5">
                        <p className="uppercase font-bold tracking-wider">
                            Podrška
                        </p>
                        <nav>
                            <ul className="my-3 tracking-wide">
                                <li className="my-2">
                                    <NavLink to={{ pathname: "https://podrska.roba.ba/kontakt/" }} title="Korisnička podrška" target={"_blank"}>Korisnička podrška</NavLink>
                                </li>
                                <li className="my-2">
                                    <NavLink to={{ pathname: "https://podrska.roba.ba/najcesce-postavljena-pitanja/" }} title="Najčešća pitanja" target={"_blank"}>Najčešća pitanja</NavLink>
                                </li>
                                <li className="my-2">
                                    <NavLink to={{ pathname: "https://podrska.roba.ba/registracija-na-roba-ba/" }} title="Uputstva" target={"_blank"}>Uputstva</NavLink>
                                </li>
                                <li className="my-2">
                                    <NavLink to={{ pathname: "https://blog.roba.ba/" }} title="Blog" target={"_blank"}>Blog</NavLink>
                                </li>
                                <li className="my-2">
                                    <NavLink to={{ pathname: "https://podrska.roba.ba/kontakt/" }} title="Kontakt" target={"_blank"}>Kontakt</NavLink>
                                </li>
                            </ul>
                        </nav>
                    </section>
                </div>
                <div className="container mx-auto md:px-0 lg:px-0">
                    <div className="flex items-center justify-center">
                        <div className="flex flex-row flex-nowrap space-x-3 md:space-x-6 lg:space-x-6 items-center justify-center bg-white py-2 px-3 rounded-lg">
                            <NavLink to={{ pathname: "https://usa.visa.com/" }} title="Visa" target={"_blank"}><img className="h-9 sm:h-12 md:h-12 lg:h-12" alt="Visa" src={visa} /></NavLink>
                            <NavLink to={{ pathname: "https://www.mastercard.com/global/en.html" }} title="Mastercard" target={"_blank"}><img className="h-9 sm:h-12 md:h-12 lg:h-12" alt="Mastercard" src={mastercard} /></NavLink>
                            <NavLink to={{ pathname: "https://www.mastercard.com/global/en.html" }} title="Maestro" target={"_blank"}><img className="h-9 sm:h-12 md:h-12 lg:h-12" alt="Maestro" src={maestro} /></NavLink>
                            <NavLink to={{ pathname: "https://monri.com/" }} title="Monri" target={"_blank"}><img className="h-9 sm:h-12 md:h-12 lg:h-12" alt="Monri" src={monri} /></NavLink>
                        </div>
                    </div>
                </div>
            </div>

            {/* foooter bottom content */}
            <div className="pt-4 pb-8 px-3 bg-indigo">
                <section className="w-full text-sm text-center">
                    <p>
                        Roba.ba &copy; 2025. Sva prava zadržana. Zabranjeno kopiranje sadržaja bez dozvole izdavača.
                    </p>
                </section>
            </div>
        </footer>
    );
}